<template>
  <div class="mb-3 text-center">
    <h4 class="formTitle" data-v-5b9eac9b=""> Добавить игрока в команду </h4>
    <div class="col-12 blockWrapper p-0">
      <MyInput label="Имя"
             name-input
             v-model="newPlayerName"
             :class="{'is-invalid': nameIsInvalid}"
      ></MyInput>
      <div v-if="nameIsInvalid" id="nameInputFeedback" class="invalid-feedback">
        Имя должно содержать не менее 2 букв!
      </div>
      <MyInput
         label="Телефон"
         phone-input
         v-model="newPlayerPhone"
         :class="{'is-invalid': phoneIsInvalid && !isChildAccount}"
         data-tel-input
         ref="phoneInput"
         :required="!isChildAccount"
         :disabled="isChildAccount"
      ></MyInput>
      <div v-if="phoneIsInvalid && !isChildAccount" id="phoneInputFeedback" class="invalid-feedback">
        Некорректный номер телефона!
      </div>

      <!-- Чекбокс "Детский аккаунт" -->
      <div class="form-check mb-3 text-start">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="isChildAccount"
          id="childAccountCheck"
        >
        <label class="form-check-label" for="childAccountCheck">
          Детский аккаунт
        </label>
      </div>
      
      <!-- Поле даты рождения (показывается только для детских аккаунтов) -->
      <div v-if="isChildAccount" class="mb-3">
        <label for="birthDate" class="form-label">Дата рождения</label>
        <input
          type="date"
          class="form-control"
          id="birthDate"
          v-model="birthDate"
          :class="{'is-invalid': birthDateIsInvalid}"
          :required="isChildAccount"
        >
        <div v-if="birthDateIsInvalid" class="invalid-feedback">
          Дата рождения обязательна для детского аккаунта!
        </div>
      </div>
    </div>

    <my-button @click="addNewPlayer" class="btn btn-secondary btn-block my-3 w-100"><span>Добавить</span></my-button>
    <div v-if="inviteLink" class="d-flex justify-content-sm-between">
      <div class="w-50"><hr></div>
      <div class="mx-3 d-flex text-center align-items-center">или</div>
      <div class="w-50"><hr></div>
    </div>
    <my-button v-if="inviteLink && glb.isMobileBrowser()" @click="shareInviteLink" cls="hollow" class="w-100 my-3">Отправить ссылку для регистрации</my-button>
    <my-button v-if="inviteLink && !glb.isMobileBrowser()" @click="copyInviteLink" cls="hollow" class="w-100 my-3">Скопировать ссылку для регистрации</my-button>
    <my-button @click="$emit('close')" cls="blue" class="w-100">Назад!</my-button>
    <input type="text" value="value" class="d-none" ref="inputcopy">
  </div>
</template>

<script>
import MyInput from "../UI/MyInput";
import {handleError} from "@/utils/error";
export default {
  name: "AddNewPlayer",
  components: {MyInput},
  props: {
    team: {type: Object, required: true},
    inviteLink:{type: String},
    showAddPlayer: {type: Boolean, required: false}
  },
  data() {
    return {
      newPlayerName: '',
      newPlayerPhone: '',
      nameIsInvalid: false,
      phoneIsInvalid: false,
      isChildAccount: false,
      birthDate: '',
      birthDateIsInvalid: false,
    }
  },
  mounted () {
    this.$nextTick(()=> {
        this.$refs.phoneInput.focus();
        this.glb.phoneInputFormatter();
      });
  },
  watch: {
    isChildAccount(newVal) {
      if (newVal) {
        // При включении детского аккаунта очищаем телефон
        this.newPlayerPhone = '';
        this.phoneIsInvalid = false;
      } else {
        // При выключении очищаем дату рождения
        this.birthDate = '';
        this.birthDateIsInvalid = false;
      }
    }
  },
  methods: {
    addNewPlayer() {
      let vm = this;
      vm.nameIsInvalid = false;
      vm.phoneIsInvalid = false;
      vm.birthDateIsInvalid = false;

      // Валидация имени (всегда требуется, минимум 2 символа)
      if (vm.newPlayerName.length < 2) {
        vm.nameIsInvalid = true;
      }

      // Валидация телефона (только для не-детских аккаунтов)
      let phoneValid = false;
      if (!vm.isChildAccount) {
        const formattedPhone = vm.glb.formatPhone(vm.newPlayerPhone);
        if ([11, 12].includes(formattedPhone.length)) {
          phoneValid = true;
        } else {
          vm.phoneIsInvalid = true;
        }
      } else {
        phoneValid = true; // Для детских аккаунтов телефон не обязателен
      }

      // Валидация даты рождения (только для детских аккаунтов)
      let birthDateValid = false;
      if (vm.isChildAccount) {
        if (vm.birthDate && vm.birthDate.trim() !== '') {
          birthDateValid = true;
        } else {
          vm.birthDateIsInvalid = true;
        }
      } else {
        birthDateValid = true; // Для не-детских дата не требуется
      }

      // Если все валидации пройдены
      if (phoneValid && birthDateValid && vm.newPlayerName.length >= 2) {
        // Подготовка данных для API
        let apiData = {
          'name': vm.newPlayerName,
          'is_child': vm.isChildAccount
        };

        // Добавляем телефон только если он есть (для детских может быть пустым)
        if (vm.newPlayerPhone && vm.glb.formatPhone(vm.newPlayerPhone)) {
          apiData['phone'] = vm.glb.formatPhone(vm.newPlayerPhone);
        }

        // Добавляем дату рождения только для детских аккаунтов
        if (vm.isChildAccount && vm.birthDate) {
          apiData['birth_date'] = vm.birthDate;
        }

        vm.$api.addPlayerInTeam(
            vm.team.id,
            apiData
        )
        .then(data=>{
          if (data.result) {
            if (data.result === 'not exists'){
              let phone = vm.newPlayerPhone;
              vm.newPlayerPhone = `${phone} нет в Whats App :(`;
              vm.phoneIsInvalid = true;
            }
          } else {
            // Очистка полей после успешного добавления
            vm.newPlayerName = '';
            vm.newPlayerPhone = '';
            vm.birthDate = '';
            vm.isChildAccount = false;
            vm.nameIsInvalid = false;
            vm.phoneIsInvalid = false;
            vm.birthDateIsInvalid = false;
            vm.$emit('add-new-player')
          }
        })
        .catch(error=>{
          console.log(error.response)
          handleError(error)
        });
      }
      // Если валидация не пройдена, флаги уже установлены выше
    },
    shareInviteLink() {
      window.open(`whatsapp://send?text=${this.inviteLink}`, 'sharer')
    },
    copyInviteLink(){
      let vm = this;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.inviteLink)
            .then(() => {
              vm.$toast.success('Ссылка скопирована в буфер.');
            })
            .catch((error) => {
              vm.$toast.error(error)
            })
      } else vm.$toast.error('упс...')
    }
  },

}
</script>

<style scoped>

.popup-modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  align-items: center;
  z-index: 1100;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.window {
  position: relative;
  background: #33347E;
  border-radius: 1rem;
  box-shadow: 2px 4px 8px rgb(0 0 0 / 20%);
  max-width: max-content;
  /*margin-left: auto;*/
  /*margin-right: auto;*/
  padding: 1.75rem;
  margin: 0 auto;
}
.window-content{
  height: 100%;
}

/* Стили для чекбокса детского аккаунта */
.form-check {
  margin: 1.75rem auto;
  max-width: 28rem;
  text-align: start;
}

.form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.3rem;
  background-color: transparent;
  border: 1px solid #fff;
  cursor: pointer;
}

.form-check-input:checked {
  background-color: #E32289;
  border-color: #E32289;
}

.form-check-input:focus {
  border-color: #fff;
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.25);
}

.form-check-label {
  color: #fff;
  font-weight: 500;
  font-size: 0.875rem;
  margin-left: 0.5rem;
  cursor: pointer;
  user-select: none;
}

/* Стили для поля даты рождения */
input[type="date"] {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background: transparent;
  border-radius: 1.25rem;
  border: 1px solid #fff;
  border-top: none;
  width: 100%;
  color: #fff;
  padding: 1rem 1.875rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type="date"]:focus {
  outline: 0;
  outline-offset: 0;
  border-color: #fff;
  box-shadow: none;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
  padding: 0.5rem;
}

input[type="date"]::-webkit-calendar-picker-indicator:hover {
  filter: invert(0.8);
}

/* Убираем стандартные стили для Firefox */
input[type="date"]::-moz-calendar-picker-indicator {
  filter: invert(1);
}

</style>
